import React from 'react'

export const BoughtSymbol = ({
  className,
  size,
}: {
  className?: string
  size: number
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 12 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M2.98535 7.92663L9.04089 1.87109'
        stroke='currentColor'
        stroke-width='0.854527'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M2.98535 3.48438L2.98535 7.92654L7.42752 7.92654'
        stroke='currentColor'
        stroke-width='0.854527'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M2.33594 9.87109L9.68909 9.87109'
        stroke='currentColor'
        stroke-width='0.854527'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  )
}
